/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReplyToChatRequest } from '../../models/reply-to-chat-request';
import { ReplyToChatResponse } from '../../models/reply-to-chat-response';

export interface PostReply$Params {
  body?: ReplyToChatRequest;
}

export function postReply(
  http: HttpClient,
  rootUrl: string,
  params?: PostReply$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ReplyToChatResponse>> {
  const rb = new RequestBuilder(rootUrl, postReply.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReplyToChatResponse>;
    }),
  );
}

postReply.PATH = '/Chats/reply';
